module.exports = __webpack_public_path__ + "static/img/active1.06aff466.png";